export const formDefaultValues = {
  name: '',
  type: 'text',
}
